/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ModeloEtapas from 'Infotrack@Modelos/smartStock/etapas';
import ModeloFlujos from 'Infotrack@Modelos/smartStock/flujos';

export default class FlujosEtapasCM {
  private modeloFlujos: ModeloFlujos;
  private modeloEtapas: ModeloEtapas;
  constructor() {
    this.modeloFlujos = new ModeloFlujos();
    this.modeloEtapas = new ModeloEtapas();
  }
  public async consultarListaEntidadesFlujosEtapas() {
    const entidades = await Promise.all([this.modeloFlujos.consultarFlujos(), this.modeloEtapas.consultarEtapas()]);
    return {
      flujoss: entidades[0].data.Entidades,
      etapass: entidades[1].data.Entidades,
    };
  }
}
